import React from "react";
import { Card, Image } from "react-bootstrap";
import { itemHeading, itemDesSmall, bioStyle } from "../components/styles";

const CardItem = ({ obj }) => {
  if (!obj) {
    return null;
  }

  const { title, subtitle, description, image, link } = obj;

  return (
    <Card
      as="a"
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      className="project-card"
    >
      <Image src={image} alt="" className="project-image" />
      <div style={{ padding: "20px" }}>
        <p style={itemDesSmall}>{subtitle}</p>
        <h3 style={itemHeading}>{title}</h3>
        <p style={{ ...bioStyle, marginTop: "12px", fontSize: "0.95rem" }}>
          {description}
        </p>
        <div style={learnMoreStyle}>
          Learn more <span style={arrowStyle}>→</span>
        </div>
      </div>
    </Card>
  );
};

const learnMoreStyle = {
  marginTop: "18px",
  fontSize: "0.95rem",
  color: "#0f766e",
  fontWeight: 800,
  textAlign: "left",
};

const arrowStyle = {
  marginLeft: "5px",
  transition: "margin-left 0.3s ease",
};

export default CardItem;
